import React from 'react';
import ReactPlayer from 'react-player';

export default class ArticleVideo extends React.Component {
  render() {
    return(
      <ReactPlayer url={this.props.src} playing={true} muted playsinline width={"100%"} height={"100%"} loop={true} wrapper={'figure'}></ReactPlayer>
    )
  }
}
